/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { AlterChangeFare, Leave, Locality, OneWay, Reset, RoundTrip, St, Warn } from "../../common/svg/AllSvg";
import SelectComponent from "../../common/form/SelectComponent";
import { useSelector } from "react-redux";
import { components } from "react-select";
import PrimaryBtn from "../../common/form/PrimaryBtn";
import { useTranslation } from "react-i18next";
import { url } from "../../../shared/utils/url";
import useAxios from "../../../shared/hooks/use-axios";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";

const Option: any = (props: any) => {
    return (
        <components.Option {...props}>{props.data.option}</components.Option>
    );
};

const TripPlanner = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const { t } = useTranslation('common');
    const [type, setType] = useState<number>(1);
    const [fromSts, setFromSts] = useState<any[]>([]);
    const [fromStOpen, setFromStOpen] = useState<any>(false);
    let [fromStPh, setFromStPh] = useState<any>(t("passenger.home.banner.trip_planner.form.from_placeholder"));
    const [toSts, setToSts] = useState<any[]>([]);
    const [toStOpen, setToStOpen] = useState<any>(false);
    let [fromStSearch, setFromStSearch] = useState<any>('');
    let [toStSearch, setToStSearch] = useState<any>('');
    let [toStPh, setToStPh] = useState<any>(t("passenger.home.banner.trip_planner.form.to_placeholder"));
    const [fromErr, setFromErr] = useState<boolean>(false)
    const [toErr, setToErr] = useState<boolean>(false)
    const [leave, setLeave] = useState<boolean>(true)
    const [dateFocus, setDateFocus] = useState<boolean>(false)
    const [date, setDate] = useState<any>(moment(new Date()).format('YYYY-MM-DDTHH:mm'))
    let [fromSt, setFromSt] = useState<any>(null)
    let [toSt, setToSt] = useState<any>(null)
    const params = useParams();
    const navigate = useNavigate();

    const handleReset: any = () => {
        setFromStPh(t("passenger.home.banner.trip_planner.form.from_placeholder"))
        setToStPh(t("passenger.home.banner.trip_planner.form.to_placeholder"))
        setFromErr(false)
        setToErr(false)
        setFromSt(null)
        setToSt(null)
        setToStSearch("")
        setFromStSearch("")
    }

    useEffect(() => {
        if (!!!fromSt || !!!fromStSearch) {
            setFromStPh(t("passenger.home.banner.trip_planner.form.from_placeholder"))
        }
        if (!!!toSt || !!!toStSearch) {
            setToStPh(t("passenger.home.banner.trip_planner.form.to_placeholder"))
        }
    }, [lang])

    const handleFromInputChanged = (input: any, reason: any) => {
        if (
            reason.action === "set-value" ||
            reason.action === "input-blur" ||
            reason.action === "menu-close"
        ) {
            return;
        }

        const regex = /^[a-zA-Z0-9 ]*$/;

        if (regex.test(input) || input === '') {
            setFromStSearch(input);
            setFromStPh("")
            input !== fromSt?.label && setFromSt(null);
        }
    };

    const handleToInputChanged = (input: any, reason: any) => {
        if (
            reason.action === "set-value" ||
            reason.action === "input-blur" ||
            reason.action === "menu-close"
        ) {
            return;
        }
        const regex = /^[a-zA-Z0-9 ]*$/;

        if (regex.test(input) || input === '') {
            setToStSearch(input);
            input !== toSt?.label && setToSt(null);
            setToStPh("")
        }
    };

    const handleFromChange = (e: any) => {
        fromSt = e;
        setFromSt(fromSt);
        !!fromSt && setFromErr(false)
        setFromStOpen(false);
        !!fromSt ? setFromStSearch(e?.label) : setFromStSearch("")
    }

    const handleToChange = (e: any) => {
        toSt = e;
        setToSt(toSt);
        !!toSt && setToErr(false)
        setToStOpen(false);
        !!toSt ? setToStSearch(e?.label) : setToStSearch("");
    }

    const handleAlterChange = () => {
        const from: any = fromSt;
        const to: any = toSt;
        const fromSearch: any = fromStSearch;
        const toSearch: any = toStSearch;
        fromSt = to;
        setFromSt(fromSt);
        toSt = from;
        setToSt(toSt)
        !!to ? setFromStSearch(to?.label) : setFromStSearch(toSearch)
        !!from ? setToStSearch(from?.label) : setToStSearch(fromSearch);
        (!!!to && !!!toSearch) && setFromStPh(t("passenger.home.banner.trip_planner.form.from_placeholder"));
        (!!!from && !!!fromSearch) && setToStPh(t("passenger.home.banner.trip_planner.form.to_placeholder"));
    }

    const getFromStations = async () => {
        try {
            let apiUrl: any = ""
            if (!!fromStSearch) {
                apiUrl = await useAxios.get(`/${(!!lang ? lang : "en") + url?.searchStOrLt}${fromStSearch}/`);
            } else {
                apiUrl = await useAxios.get(`/${(!!lang ? lang : "en") + url?.searchStOrLt}`);
            }

            if (!!apiUrl) {
                const res: any = apiUrl;

                if (res && res?.status === 200) {
                    let stArr: any[] = res?.data[0]?.stations?.map((item: any) => ({
                        label: item?.name,
                        code: item?.code,
                        value: item?.code,
                        option: <div className="flex items-center">
                            <div className="pr-[8px]">
                                <St />
                            </div>
                            <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{item?.name}</p>
                        </div>,
                        type: "station"
                    }))

                    let ltArr: any[] = res?.data[0]?.localities?.map((item: any) => ({
                        label: item?.name,
                        code: item?.name,
                        value: item?.name,
                        option: <div className="flex items-center">
                            <div className="pr-[8px]">
                                <Locality />
                            </div>
                            <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{item?.name}</p>
                        </div>,
                        type: "locality"
                    }))


                    let arr: any[] = stArr.concat(ltArr)
                    setFromSts(arr)

                    if (!!fromSt) {
                        let obj: any = arr?.find((item: any) => fromSt?.value === item?.value)
                        setFromSt(obj)
                        setFromStSearch(obj?.label)
                    }
                }
            }
        } catch (error) {
            console.error("error while feching stations or locality", error);
        }
    }

    useEffect(() => {
        !!lang && getFromStations();
    }, [lang, fromStSearch])

    useEffect(() => {
        fromStSearch?.length === 0 && setFromSts([])
    }, [fromStSearch])

    const getToStations = async () => {
        try {
            let apiUrl: any = ""
            if (!!toStSearch) {
                apiUrl = await useAxios.get(`/${(!!lang ? lang : "en") + url?.searchStOrLt}${toStSearch}/`);
            } else {
                apiUrl = await useAxios.get(`/${(!!lang ? lang : "en") + url?.searchStOrLt}`);
            }

            if (!!apiUrl) {
                const res: any = apiUrl;

                if (res && res?.status === 200) {
                    let stArr: any[] = res?.data[0]?.stations?.map((item: any) => ({
                        label: item?.name,
                        code: item?.code,
                        value: item?.code,
                        option: <div className="flex items-center">
                            <div className="pr-[8px]">
                                <St />
                            </div>
                            <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{item?.name}</p>
                        </div>,
                        type: "station"
                    }))

                    let ltArr: any[] = res?.data[0]?.localities?.map((item: any) => ({
                        label: item?.name,
                        code: item?.name,
                        value: item?.name,
                        option: <div className="flex items-center">
                            <div className="pr-[8px]">
                                <Locality />
                            </div>
                            <p className="text-sm xlx:text-base font-bold text-[#5A5A5A]">{item?.name}</p>
                        </div>,
                        type: "locality"
                    }))

                    let arr: any[] = stArr.concat(ltArr)
                    setToSts(arr)

                    if (!!toSt) {
                        let obj: any = arr?.find((item: any) => toSt?.value === item?.value)
                        setToSt(obj)
                        setToStSearch(obj?.label)
                    }
                }
            }
        } catch (error) {
            console.error("error while feching stations or locality", error);
        }
    }

    useEffect(() => {
        !!lang && getToStations();
    }, [lang, toStSearch])

    useEffect(() => {
        toStSearch?.length === 0 && setToSts([])
    }, [toStSearch])

    const handleNavigate = async () => {
        if (!!!fromSt && !!!toSt) {
            setFromErr(true)
            setToErr(true)
            return;
        }

        if (!!!fromSt) {
            setFromErr(true)
            return;
        }

        if (!!!toSt) {
            setToErr(true)
            return;
        }


        if (params?.lang) {
            navigate(`/${params?.lang}/map?from=${fromSt?.code}&fromName=${fromSt?.label}&to=${toSt?.code}&toName=${toSt?.label}&fromType=${fromSt?.type}&toType=${toSt?.type}&date=${date}&journey=${type === 1 ? "one_way" : "round_way"}`);
        } else {
            navigate(`/map?from=${fromSt?.code}&fromName=${fromSt?.label}&to=${toSt?.code}&toName=${toSt?.label}&fromType=${fromSt?.type}&toType=${toSt?.type}&date=${date}&journey=${type === 1 ? "one_way" : "round_way"}`);
        }
    }

    return (
        <div className="col-span-1 w-full rounded-[20px] dark:bg-bgPrimaryDark bg-primary backdrop-blur-[0.5px] h-full py-[8px] px-[5px] !pt-0">
            <div className="h-[38px] px-[20px] flex items-center">
                <h4 className="text-white uppercase font-extrabold">{t("passenger.home.banner.trip_planner.title")}</h4>
            </div>

            <form onSubmit={(e: any) => { e.preventDefault(); handleNavigate(); }} style={{ filter: "drop-shadow(0px 4px 4px rgba(24, 39, 75, 0.08)) drop-shadow(0px 2px 4px rgba(24, 39, 75, 0.12))" }} className="dark:bg-bgDarkDull bg-white border dark:border-[#5B5B5B] border-[#CECECE] rounded-[20px] h-[calc(100%-38px)] sm:p-[20px] p-[15px] flex flex-col relative min-h-[375px]" noValidate>
                <div className="flex items-center gap-[10px] relative z-[1]">
                    <button type="button" className={`${type === 1 ? "dark:bg-[#34384F] bg-white border dark:border-[#1361AA] border-[#9ACFFF] dark:text-textBlackDull text-primaryText" : "border dark:border-[#373d4a] border-[#8585855e] dark:bg-bgDarkDull bg-white text-[#858585] dark:text-white dark:text-opacity-[0.5]"} rounded-[10px] h-[30px] flex items-center gap-[8px] px-[10px] sm:px-[13px] font-semibold focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] dark:focus:shadow-[0_0_0_2px_#1361AA5e] dark:hover:shadow-[0_0_0_2px_#1361AA5e] text-sm leading-snug`} onClick={() => setType(1)}>
                        <OneWay className={`${type === 1 ? "fill-primaryText dark:fill-textBlackDull" : "fill-[#858585]"}`} />
                        <h5>{t("passenger.home.banner.trip_planner.one_way")}</h5>
                    </button>
                    <button type="button" className={`${type === 2 ? "dark:bg-[#34384F] bg-white border dark:border-[#1361AA] border-[#9ACFFF] dark:text-textBlackDull text-primaryText" : "border dark:border-[#373d4a] border-[#8585856e] dark:bg-bgDarkDull bg-white text-[#858585] dark:text-white dark:text-opacity-[0.5]"} rounded-[10px] h-[30px] flex items-center gap-[8px] px-[10px] sm:px-[13px] font-semibold focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] dark:focus:shadow-[0_0_0_2px_#1361AA5e] dark:hover:shadow-[0_0_0_2px_#1361AA5e] text-sm leading-snug`} onClick={() => setType(2)}>
                        <RoundTrip className={`${type === 2 ? "fill-primaryText dark:fill-textBlackDull" : "fill-[#858585]"}`} />
                        <h5>{t("passenger.home.banner.trip_planner.round_trip")}</h5>
                    </button>
                </div>

                <div className="flex flex-col mt-[15px] relative z-[1]">
                    <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("passenger.home.banner.trip_planner.form.title")}</h6>

                    <div className="flex flex-col mt-[10px] relative gap-[4.19px]">
                        <div className='flex flex-col'>
                            <SelectComponent
                                options={fromSts.filter(item => item?.code !== toSt?.code)}
                                name="from"
                                placeholder={fromStSearch || fromStPh}
                                title={t("passenger.home.banner.trip_planner.form.from")}
                                onFocus={() => setFromStPh("")}
                                menuIsOpen={fromStOpen}
                                onMenuOpen={() => setFromStOpen(true)}
                                onMenuClose={() => setFromStOpen(false)}
                                onBlur={() => { !!!fromStSearch && setFromStPh(t("passenger.home.banner.trip_planner.form.from_placeholder")) }}
                                value={fromSt}
                                onChange={(e: any) => handleFromChange(e)}
                                inputValue={fromStSearch}
                                onInputChange={handleFromInputChanged}
                                components={{ Option }}
                                arrow={false}
                            />
                        </div>

                        <div className='flex items-center w-fit justify-end absolute right-0 top-[44px] pr-[35px] z-[1]'>
                            <button title={t("aria_label.switch_st")} aria-label={t("aria_label.switch_st")} type="button" className='cursor-pointer min-w-[33px] min-h-[33px] xl:min-w-[36px] xl:min-h-[36px] rounded-full border border-[rgba(134,134,134,0.25)] dark:bg-[rgba(42,44,56,0.30)] bg-white flex items-center justify-center focus:shadow-[0_0_0_2px_#00376D5e] hover:shadow-[0_0_0_2px_#00376D5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e] backdrop-blur-[7px]' onClick={handleAlterChange}>
                                <AlterChangeFare />
                            </button>
                        </div>

                        <div className='flex flex-col'>
                            <SelectComponent
                                options={toSts.filter(item => item?.code !== fromSt?.code)}
                                name="to"
                                placeholder={toStSearch || toStPh}
                                title={t("passenger.home.banner.trip_planner.form.to")}
                                onFocus={() => setToStPh("")}
                                menuIsOpen={toStOpen}
                                onMenuOpen={() => setToStOpen(true)}
                                onMenuClose={() => setToStOpen(false)}
                                onBlur={() => { !!!toStSearch && setToStPh(t("passenger.home.banner.trip_planner.form.to_placeholder")) }}
                                value={toSt}
                                onChange={(e: any) => handleToChange(e)}
                                inputValue={toStSearch}
                                onInputChange={handleToInputChanged}
                                components={{ Option }}
                                arrow={false}
                            />
                        </div>
                    </div>


                    {/* ${dateFocus && "shadow-lg bg-white"} hover:shadow-lg hover:bg-white */}
                    {/* <div className='mt-[15px]'>
                        <div className={`w-full xsm:w-[250px] rounded-[10px] border border-[rgba(134,134,134,0.25)] dark:bg-[#191919] bg-[#F8F8F8] flex flex-col px-[12px] sm:px-[17px] pt-[8px] `} >
                            <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("passenger.home.banner.trip_planner.form.departure")}</h6>
                            {leave ?
                                <button type="button" className="w-full flex items-center justify-between gap-[8px] mt-[-4px] disabled:opacity-[0.7] disabled:cursor-not-allowed" disabled onFocus={() => { setLeave(false); setDateFocus(true) }} onClick={() => { setLeave(false); setDateFocus(false) }} >
                                    <h4 className="text-primaryText dark:text-textBlackDull font-semibold h-[32px] xlx:h-[35px] flex items-center">{t("passenger.home.banner.trip_planner.form.leaving_now")}</h4>
                                    <div className="mb-[2px]">
                                        <Leave className="fill-[#1c1b1f4d] dark:fill-textBlackDull" />
                                    </div>
                                </button>
                                :
                                <div className="w-full flex items-center justify-between gap-[8px] mt-[-4px]">
                                    <input
                                        title=""
                                        type="datetime-local"
                                        id="datepicker"
                                        name="datetime-picker"
                                        value={date}
                                        onChange={(e: any) => setDate(e.target.value)}
                                        min={moment(new Date()).format('YYYY-MM-DDTHH:mm')}
                                        className="w-full h-[32px] xlx:h-[35px] font-semibold text-lg text-primaryText dark:text-textBlackDull !bg-transparent custom-date-input"
                                        onFocus={() => setDateFocus(true)}
                                        onBlur={() => setDateFocus(false)}
                                        autoFocus
                                        autoComplete=""
                                    />
                                </div>
                            }
                        </div>

                        {(fromErr || toErr) && <div className="flex gap-[6px] items-start mt-[4px]"><Warn />
                            <span className="text-danger text-xs font-medium dark:text-darkDanger">{t("passenger.home.fare.err")}</span>
                        </div>}
                    </div> */}
                </div>

                <div className={`flex items-center justify-between w-full mt-[25px] ${(fromStOpen || toStOpen) ? "" : "relative z-[0]"}`}>
                    <button type="button" className="flex items-center justify-center gap-[7px] dark:text-darkDanger text-danger font-bold uppercase disabled:opacity-[0.5] disabled:cursor-not-allowed focus:shadow-[0_0_0_2px_#ff00005e] hover:shadow-[0_0_0_2px_#ff00005e] dark:focus:shadow-[0_0_0_2px_#FF5B5B5e] dark:hover:shadow-[0_0_0_2px_#FF5B5B5e] focus:rounded-[4px] hover:rounded-[4px] disabled:rounded-none disabled:shadow-none disabled:dark:shadow-none py-[1px] px-[6px] text-sm leading-snug" disabled={(!!fromStSearch || !!toStSearch) ? false : true} onClick={handleReset}><Reset /> <span className="pt-[2px]">{t("passenger.home.banner.trip_planner.form.reset")}</span></button>
                    <PrimaryBtn title={t("passenger.home.banner.trip_planner.form.plan_journey")} onClick={handleNavigate} />
                </div>

                <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full flex items-end justify-end z-[-1]">
                    <img src={require("../../../assets/images/planjourney-bg.png")} alt="planjourney-bg" className="rounded-b-[20px] w-full dark:sepia md:block xsm:hidden block" />
                    <img src={require("../../../assets/images/planjourney-bg1.png")} alt="planjourney-bg" className="rounded-b-[20px] w-full dark:sepia md:hidden hidden xsm:block" />
                </div>
            </form>
        </div>
    );
};

export default TripPlanner;